import Box from '@mui/material/Box'
import StaticPageTypography from 'components/staticPage/StaticPageTypography'
import StaticPageWrapper from 'components/staticPage/StaticPageWrapper'
import { useTranslation } from 'react-i18next'

const UnknownError = () => {
    const { t } = useTranslation('common')

    return (
        <StaticPageWrapper
            title={t('errors.unknownError')}
            withContact={true}
            withHomeButton={true}
        >
            <Box style={{ marginBottom: '2vh' }}>
                <StaticPageTypography variant="h6">
                    {t('errors.unexpected')}
                </StaticPageTypography>
            </Box>
        </StaticPageWrapper>
    )
}

export default UnknownError
